import { Color } from "$lib/utility/color";
import { fetchStore, persistedWritable } from "ceyper-common";
import { writable } from "svelte/store";

type Palette = {
    name: string;
    colors: Color[];
};

type PaletteTemplate = {
    name: string;
    colors: string[];
};

export function createPalette(name: string, template: PaletteTemplate) {
    const colors = template.colors.map(Color.fromHex);

    return {
        name,
        colors,
    };
}

const serializeColor = {
    parse: (text: string) => Color.fromHex(JSON.parse(text)) as Color,
    stringify: (object: Color) => JSON.stringify(Color.asHex(object)),
};

const serializePalette = {
    parse(text: string) {
        const obj = JSON.parse(text);

        return {
            name: obj.name,
            colors: obj.colors.map(Color.fromHex),
        };
    },
    stringify(object: Palette) {
        return JSON.stringify({
            name: object.name,
            colors: object.colors.map(Color.asHex),
        });
    },
};

export const palette = {
    active: persistedWritable<Palette>(
        "palette-active",
        { name: "default", colors: [Color.white, Color.black] },
        { serializer: serializePalette }
    ),
    index: persistedWritable("palette-index", 0),

    primary: persistedWritable("palette-primary", Color.black, { serializer: serializeColor }),
};

function setPalette(pal: Palette) {
    palette.active.set(pal);
    palette.index.set(0);
    palette.primary.set(pal.colors[0]);
}

export const availableTemplates = fetchStore<string[]>("/palettes/index.json", {
    initialValue: [],
    errorValue: [],
});

let loading = -1;
export const isLoadingPalette = writable(false);
export async function loadPalette(name: string) {
    let id = ++loading;
    isLoadingPalette.set(true);
    const res = await fetch(`/palettes/${name}.json`);
    const template = (await res.json()) as PaletteTemplate;

    if (loading !== id) return;

    if (template) {
        setPalette(createPalette(name, template));
    }

    isLoadingPalette.set(false);
}

// default palette
if (palette.active.value.name === "default") {
    loadPalette("LOSPEC500");
}
